import { useState } from "react";
import { useParams } from "react-router-dom";
import ToolPageView from "./ToolPageView";
import useCustomEffect from "../../../hooks/useCustomEffect";
import { useRouteContext } from "../../../context/RouteContext";
import useEvaApi, { EvaApiCall } from "../../../hooks/useEvaApi";
import useEntityTranslations, {
  mapResponseTranslations,
} from "../../../hooks/useEntityTranslations";

function ToolPage() {
  const callEvaApi = useEvaApi();
  const routeContext = useRouteContext();
  const { tool } = useParams();
  const [submitError, setSubmitError] = useState(null);
  const [toolData, setToolData] = useState({
    name: "",
    order: 0,
    translations: [],
  });

  const translationsController = useEntityTranslations(
    toolData.translations,
    onTranslationsChange,
  );

  /**
   * initialize the component
   */
  useCustomEffect(() => {
    if (tool) {
      fetchToolData();
    }
  });

  /**
   * This method will fetch the calamity tool data from the API
   */
  async function fetchToolData() {
    await callEvaApi(
      new EvaApiCall(`calamity_tools/${tool}`)
        .setLoadingGroup("calamities_tool_page_fetch")
        .setOnSuccess((response) => {
          setToolData({
            name: response.data.data.name,
            order: response.data.data.order,
            translations: mapResponseTranslations(
              response.data.data.translations,
              (translation) => ({
                label: translation.label,
              }),
            ),
          });
        })
        .setRedirectOnError(true),
    );
  }

  /**
   * This method will update the name on input change
   * @param {event} e
   */
  function onNameChange(e) {
    setToolData({ ...toolData, name: e.target.value });
  }

  /**
   * This method will update the order on input change
   * @param {event} e
   */
  function onOrderChange(e) {
    setToolData({ ...toolData, order: e.target.value });
  }

  /**
   * This method will handle the translations change
   * @param {array} value
   */
  function onTranslationsChange(value) {
    setToolData((current) => ({
      ...current,
      translations: value,
    }));
  }

  /**
   * This method will handle the onCancel functionality
   */
  function onCancel() {
    routeContext.back();
  }

  /**
   * This method will submit the form to the EVA API and handles its response
   */
  async function onSubmit() {
    await callEvaApi(
      new EvaApiCall(tool ? `calamity_tools/${tool}` : "calamity_tools")
        .setLoadingGroup("calamities_tool_page_submit")
        .setMethod(tool ? "PUT" : "POST")
        .setData(toolData)
        .setErrorState(setSubmitError)
        .setRedirectOnSuccess(true),
    );
  }

  return (
    <ToolPageView
      toolData={toolData}
      translationsController={translationsController}
      onNameChange={onNameChange}
      onOrderChange={onOrderChange}
      onCancel={onCancel}
      onSubmit={onSubmit}
      submitError={submitError}
    />
  );
}

export default ToolPage;
